import { provideEditorInstance } from 'application/editor/editorSingleton';
/* eslint-disable @typescript-eslint/no-unused-vars */
/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/
/* eslint-disable @typescript-eslint/no-use-before-define */

import type { RenderersManager } from 'application/render/renderers/RenderersManager';
import type { Operation } from 'domain/entities/Operation';

export class ReinitializeModeOperation implements Operation {
  public priority = 2;

  public execute(_renderersManager: RenderersManager) {
    const editor = provideEditorInstance();

    editor.mode.initialize(false);
  }

  public invert(_renderersManager: RenderersManager) {
    const editor = provideEditorInstance();

    editor.mode.initialize(false);
  }
}

export class RestoreSequenceCaretPositionOperation implements Operation {
  constructor(
    private readonly previousPosition: number,
    private readonly nextPosition: number,
    private readonly setCaretPosition: (position: number) => void,
  ) {
    this.execute();
  }

  public execute() {
    this.setCaretPosition(this.nextPosition);
  }

  public invert(_renderersManager: RenderersManager) {
    this.setCaretPosition(this.previousPosition);
  }
}
